
import React, { useState, useEffect, useCallback } from 'react';
import { getWhatsAppUrl } from '../config/constants';
import './Carousel.css';

const slides = [
  {
    id: 1,
    // h2 en lugar de h1 — SEO: solo debe haber un h1 por página
    title: '¡Haz de tu boda un recuerdo inolvidable!',
    description:
      'Captura cada momento mágico de tu día especial con nuestra cabina 360°. Tus invitados se divertirán y tú tendrás recuerdos únicos para toda la vida.',
    buttonText: '¡Quiero mi boda épica!',
    image: 'https://cdn.abacus.ai/images/fd75dbba-7da1-4ef8-96a8-db6d7a9e7d78.png',
  },
  {
    id: 2,
    title: '¡Celebra tus XV con estilo y diversión!',
    description:
      'Tu fiesta de XV años será la más comentada. Nuestra cabina 360° hará que todos tus amigos quieran estar en cada video. ¡Prepárate para brillar!',
    buttonText: '¡Quiero mis XV perfectos!',
    image: 'https://cdn.abacus.ai/images/b55219e6-8aee-48b6-910b-18b0b53f8821.png',
  },
  {
    id: 3,
    title: '¡Momentos únicos para tus eventos sociales!',
    description:
      'Cumpleaños, graduaciones, reuniones... cualquier excusa es buena para crear recuerdos increíbles. Nosotros ponemos la diversión, tú solo disfruta.',
    buttonText: '¡Llévenme la cabina!',
    image: 'https://cdn.abacus.ai/images/4bdfdbd3-381c-4119-ac3c-e19bc9225022.png',
  },
];

function Carousel() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  }, []);

  const prevSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  }, []);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    if (isPaused) return;
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [isPaused, nextSlide]);

  return (
    <section
      className="carousel"
      aria-label="Presentación de servicios ProCam360"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="carousel-container">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
            aria-hidden={index !== currentSlide}
          >
            <div className="carousel-overlay">
              <div className="carousel-content">
                {/* h2 correcto — el h1 de la página está en el layout principal */}
                <h2>{slide.title}</h2>
                <p>{slide.description}</p>
                <button
                  className="btn btn-primary btn-glow"
                  onClick={() =>
                    window.open(
                      getWhatsAppUrl(`¡Hola! Me interesa cotizar para mi evento: ${slide.title}`),
                      '_blank'
                    )
                  }
                >
                  {slide.buttonText}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Controles prev / next */}
      <button
        className="carousel-btn carousel-btn-prev"
        onClick={prevSlide}
        aria-label="Diapositiva anterior"
      >
        <i className="fas fa-chevron-left"></i>
      </button>
      <button
        className="carousel-btn carousel-btn-next"
        onClick={nextSlide}
        aria-label="Siguiente diapositiva"
      >
        <i className="fas fa-chevron-right"></i>
      </button>

      {/* Indicadores de posición */}
      <div className="carousel-indicators" role="tablist" aria-label="Diapositivas">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            role="tab"
            aria-selected={index === currentSlide}
            aria-label={`Ir a diapositiva ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}

export default Carousel;
